import { Box, styled } from '@material-ui/core';
import { SBreadcrumbs, SCheckbox } from '@setvi/shared/components';
import { Product, ProductCategoryBreadcrumb } from '@setvi/shared/interfaces';
import { distances } from '@setvi/shared/styles';
import { ROUTES } from 'enumsV2';

const Wrapper = styled(Box)({
  height: 56,
  display: 'flex',
  alignItems: 'center',
  background: '#EEF0F2',
  padding: distances.px.base,
  gap: distances.px.base
});

interface FooterProps {
  readOnly: boolean;
  product: Product;
  canSelectProducts: boolean;
  selectedProducts: Product[];
  handleProductSelect: (isChecked: boolean, product: Product[]) => void;
}

export const Footer = ({
  product,
  readOnly,
  canSelectProducts,
  selectedProducts,
  handleProductSelect
}: FooterProps) => {
  const hasBreadcrumbs = product?.categories?.[0]?.breadcrumbs?.length > 0;

  if (!hasBreadcrumbs && !canSelectProducts) return null;

  return (
    <Wrapper justifyContent={hasBreadcrumbs ? 'space-between' : 'flex-end'}>
      {hasBreadcrumbs && (
        <SBreadcrumbs<ProductCategoryBreadcrumb>
          {...(!readOnly && {
            onBreadcrumbClick: breadcrumb =>
              window.open(
                `${ROUTES.PRODUCTS_LIST_VIEW}&categoryId=${breadcrumb?._id}`,
                '_blank'
              )
          })}
          parseBreadcrumb={breadcrumb => breadcrumb?.name}
          items={product?.categories?.[0]?.breadcrumbs || []}
          fontWeight={400}
        />
      )}
      {canSelectProducts && (
        <Box display="flex" alignItems="center" gridGap="8px">
          Select this Product
          <SCheckbox
            checked={!!selectedProducts?.find(i => i?.sku === product?.sku)}
            onChange={(_, isChecked) =>
              handleProductSelect(isChecked, [product])
            }
          />
        </Box>
      )}
    </Wrapper>
  );
};
